import styled from "styled-components";
import { getTypeValue } from "../../../../base/style";

const buttonHeightList = [32, 40];
const borderList = [
  "0px solid var(--hig-color-correct)",
  "1px solid var(--hig-color-correct)",
  "1px solid #d5d5d5",
  "2px solid var(--hig-color-correct)",
  "1px solid var(--hig-color-primary)",
  "1px solid transparent",
];

const Button = styled.button`
    width: ${(props) => props.style_width};
    min-width: ${(props) => props.style_min_width};
    max-width: ${(props) => props.style_maxWidth};
    height: ${(props) =>
      getTypeValue(true, props.style_height, buttonHeightList, "px")};
    outline: none;
    transition: 0.3s;
    pointer-events: all;
    display: ${(props) => props.style_display};
    flex-direction: ${(props) => props.style_flexDirection};
    justify-content: ${(props) => props.style_justifyContent};
    align-items: ${(props) => props.style_alignItems};
    border-radius: ${(props) =>
      getTypeValue(true, props.style_borderRadius, props.theme.radius, "px")};
    background-color: ${(props) =>
      getTypeValue(false, props.style_backgroundColor, props.theme.colors)};
    background: ${(props) =>
      getTypeValue(false, props.style_background, props.theme.colors)};
    border: ${(props) => getTypeValue(true, props.style_border, borderList)};
    color: ${(props) =>
      getTypeValue(false, props.style_color, props.theme.colors)};
    font-size: ${(props) =>
      getTypeValue(true, props.style_fontSize, props.theme.fontSizes, "px")};
    font-weight: ${(props) => props.style_fontWeight};
    padding-top: ${(props) =>
      getTypeValue(true, props.style_paddingTop, props.theme.sizes, "px")};
    padding-bottom: ${(props) =>
      getTypeValue(true, props.style_paddingBottom, props.theme.sizes, "px")};
    padding-left: ${(props) =>
      getTypeValue(true, props.style_paddingLeft, props.theme.sizes, "px")};
    padding-right: ${(props) =>
      getTypeValue(true, props.style_paddingRight, props.theme.sizes, "px")};
    margin-top: ${(props) =>
      getTypeValue(true, props.style_marginTop, props.theme.sizes, "px")};
    margin-bottom: ${(props) =>
      getTypeValue(true, props.style_marginBottom, props.theme.sizes, "px")};
    margin-left: ${(props) =>
      getTypeValue(true, props.style_marginLeft, props.theme.sizes, "px")};
    margin-right: ${(props) =>
      getTypeValue(true, props.style_marginRight, props.theme.sizes, "px")};
    font-family: ${(props) => props.style_fontFamily};
    &:disabled {
        background-color: ${(props) =>
          getTypeValue(
            false,
            props.style_backgroundColor_disabled,
            props.theme.colors
          )};
        color: ${(props) =>
          getTypeValue(false, props.style_color_disabled, props.theme.colors)};
        border: ${(props) =>
          getTypeValue(true, props.style_border_disabled, borderList)};

        cursor: not-allowed;
    }

    &:hover:not([disabled]) {
        border-radius: ${(props) =>
          getTypeValue(
            true,
            props.style_borderRadius_hover,
            props.theme.radius,
            "px"
          )};
        background-color: ${(props) =>
          getTypeValue(
            false,
            props.style_backgroundColor_hover,
            props.theme.colors
          )};
        
        background: ${(props) =>
          getTypeValue(true, props.style_background_hover, props.theme.colors)}

        color: ${(props) =>
          getTypeValue(false, props.style_color_hover, props.theme.colors)};
        border: ${(props) =>
          getTypeValue(true, props.style_border_hover, borderList)};
    }

    &:active:not([disabled]) {
        border-radius: ${(props) =>
          getTypeValue(
            true,
            props.style_borderRadius_active,
            props.theme.radius,
            "px"
          )};
        background-color: ${(props) =>
          getTypeValue(
            false,
            props.style_backgroundColor_active,
            props.theme.colors
          )};
        color: ${(props) =>
          getTypeValue(false, props.style_color_active, props.theme.colors)};
        border: ${(props) =>
          getTypeValue(true, props.style_border_active, borderList)};
    }
`;

Button.defaultProps = {
  style_height: "type-0",
  style_width: "auto",
  style_min_width: "auto",
  style_maxWidth: "auto",
  style_border: "type-0",
  style_backgroundColor: "type-secondary",
  style_borderRadius: "type-5",
  style_display: "flex",
  style_flexDirection: "row",
  style_justifyContent: "center",
  style_alignItems: "center",
  style_color: "white",
  style_fontSize: "type-3",
  style_fontFamily: "inherit",
  style_fontWeight: "normal",
  style_paddingTop: "0",
  style_paddingBottom: "0",
  style_paddingLeft: "0",
  style_paddingRight: "0",
  style_marginTop: "0",
  style_marginBottom: "0",
  style_marginLeft: "0",
  style_marginRight: "0",

  // style_border_hover: "type-1",
  // style_backgroundColor_hover: "type-secondary-hover",
  style_color_hover: "white",

  style_border_active: "type-0",
  // style_backgroundColor_active: "type-secondary-active",
  style_color_active: "white",

  style_border_disabled: "type-0",
  style_backgroundColor_disabled: "#ebebeb",
  style_color_disabled: "#aaa",
};

export default Button;
